var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top"},[_c('h1',{staticClass:"ml-2"},[_vm._v("ROD "),_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Structures")])])]),_c('div',{staticClass:"body"},[_vm._l((_vm.structuresSorted),function(structure){return [_c('Structure',{attrs:{"structure":structure}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }